export const USER_ROLES = {
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPERADMIN',
    OPERATOR: 'OPERATOR',
};

export const ADMIN_TYPES = [
    { type: USER_ROLES.ADMIN, name: 'Admin' },
    { type: USER_ROLES.SUPER_ADMIN, name: 'Super Admin' },
    { type: USER_ROLES.OPERATOR, name: 'Operator' },
];

export const ADMIN_TYPES_FOR_ADMIN = [
    { type: USER_ROLES.ADMIN, name: 'Admin' },
    // { type: USER_ROLES.SUPER_ADMIN, name: 'System Admin' },
    { type: USER_ROLES.OPERATOR, name: 'Operator' },
];

export const CMS_ROUTES = [
    // { type: 'description', name: 'Танилцуулга' },
    { type: 'admin_config', name: 'Админ тохиргоо' },
    { type: 'program_list', name: 'Хөтөлбөр' },
];

export const SESSION_NAME = 'session_id';
export const LOCAL_STORAGE_USER = 'user';

export const BOOLEAN_TYPES = [
    { type: true, name: 'Тийм' },
    { type: false, name: 'Үгүй' },
];

export const APPROVE_STATUS_WAITING = 'waiting';
export const APPROVE_STATUS_APPROVED = 'approved';
export const APPROVE_STATUS_DISAPPROVED = 'disapproved';
